export default {
  props: {
    name: {
      type: String,
      required: true
    },
    x: {
      validator (value) {return !isNaN(value)},
      required: true
    },
    y: {
      validator (value) {return !isNaN(value)},
      required: true
    },
    offsetX: {
      validator (value) {return !isNaN(value)},
      default: 0
    },
    offsetY: {
      validator (value) {return !isNaN(value)},
      default: 0
    },
    scaleX: {
      validator (value) {return !isNaN(value)},
      default: 1
    },
    scaleY: {
      validator (value) {return !isNaN(value)},
      default: 1
    },
    rotation: {
      validator (value) {return !isNaN(value)},
      default: 0
    },
    allowTransformerStretch: {
      type: Boolean,
      default: true
    },
    allowTransformerScale: {
      type: Boolean,
      default: true
    },
    allowTransformerRotate: {
      type: Boolean,
      default: true
    },
    transformerTargetName: String,
    isStatic: Boolean,
    draggable: Boolean
  },
  data () {
    return {baseName: undefined}
  },
  computed: {
    config () {
      const {name, x, y, scaleX, scaleY, offsetX, offsetY, rotation} = this.$props
      return {
        name, 
        x: parseFloat(x), 
        y: parseFloat(y), 
        scaleX: parseFloat(scaleX), 
        scaleY: parseFloat(scaleY),
        offsetX: parseFloat(offsetX),
        offsetY: parseFloat(offsetY),
        rotation,
        allowTransformerRotate: this.allowTransformerRotate,
        allowTransformerScale: this.allowTransformerScale,
        allowTransformerStretch: this.allowTransformerStretch,
        transformerTargetName: this.transformerTargetName,
        isStatic: this.isStatic,
      }
    },
    elementConfig () {
      const {height, width, fill} = this.config
      return {
        name: this.name,
        baseName: this.name,
        transformerTargetName: this.transformerTargetName,
        height: parseFloat(height),
        width: parseFloat(width),
        fill: fill || 'lightblue',
      }
    }
  },
}